import { onDocumentReady } from './utils/document-ready';
import {
  lazyLoadComponentOnce,
  lazyLoadComponent,
  loadComponent,
} from './utils/loader';

import SiteNav from './components/site-nav';
import MobileMenu from './components/mobile-menu';
import ThemeToggle from './components/theme-toggle';
import CreateExternalLinks from './components/link-tool-tips';

onDocumentReady(() => {
  // Include the following components in the main bundle.
  loadComponent(SiteNav, '#js-site-nav');
  loadComponent(ThemeToggle, '#js-theme-toggle');
  loadComponent(MobileMenu, '.js-mobile-menu');
  loadComponent(CreateExternalLinks, 'body');

  // Lazy load the following components only when they are needed.
  lazyLoadComponent(
    () => import('./components/people-accordion'),
    '.js-people-accordion',
  );

  lazyLoadComponent(
    () => import('./components/dept-card-carousel'),
    '.js-dept-cards',
  );

  lazyLoadComponent(() => import('./components/tabs'), '.js-tabs');

  lazyLoadComponentOnce(
    () => import('./components/vertical-video'),
    '.js-vertical-video',
  );

  lazyLoadComponentOnce(() => import('./components/video'), '.js-video');

  lazyLoadComponent(
    () => import('./components/liquid-comet'),
    '.js-liquid-comet',
  );

  lazyLoadComponent(
    () => import('./components/animated-stat-list'),
    '.js-stats',
  );

  lazyLoadComponent(
    () => import('./components/newsletter-form'),
    '.js-newsletter',
  );

  lazyLoadComponent(
    () => import('./components/youtube-cover'),
    '.js-youtube-cover',
  );

  lazyLoadComponent(
    () => import('./components/vimeo-cover'),
    '.js-vimeo-cover',
  );

  lazyLoadComponent(
    () => import('./components/link-list-image-hover'),
    '.js-list-item-image-hover',
  );
});
